
<component
  :is="as"
  class="collection-grid-card"
  v-bind="$attrs"
  v-on="$listeners"
>
  <div class="image-container">
    <img v-lazy="{ src: card.imageCustom || card.image, error: lightErrorImage }" class="fade" />
  </div>
</component>
